module.exports = __webpack_public_path__ + "img/prepare.76b0ecbb.svg";